export default __webpack_public_path__ + "static/media/bridal3.9875e2f5.jpg";